import { render, staticRenderFns } from "./PriceControlList.vue?vue&type=template&id=a9430254&scoped=true&"
import script from "./PriceControlList.vue?vue&type=script&lang=js&"
export * from "./PriceControlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9430254",
  null
  
)

export default component.exports